import React, { Component, Children } from "react";
import { createPortal } from "react-dom";
import { Button, Space } from 'antd';
import { language } from "@/utils/language";  

import "./slick.less"
export default class Dialog extends Component {
  constructor(props) {
    super(props);
    const doc = window.document;
    this.node = doc.createElement("div");
    doc.body.appendChild(this.node);
  }
  componentWillUnmount() {
    window.document.body.removeChild(this.node);
  }
  render() {
    const { dialogMsg , cb } = this.props;
    return createPortal(
      <div className="dialogBox" style={{ zIndex: 111,background: "rgba(0,0,0,.4)"}}>
        <div className="dialog" style={{  fontSize:15  }}>
          {/* <button onClick={hideDialog}>close</button> */}
          <div style={{display:"flex" ,padding:4}}>
            <div style={{flex:"1"}}></div>
            <div style={{width:5,cursor:"pointer"}} onClick={cb}>
               <div  style={{fontSize:25,marginRight:10,float:"right"}} >x</div>

            </div>
          </div>
          <div className="pophidecontent" style={{ overflow: "auto", padding:  "0 20px", lineHeight: '22px',marginTop:"0px" }}>
            <div  dangerouslySetInnerHTML={{__html:dialogMsg}}></div>
          </div>
          <div style={{  padding:10}}>
          <div style={{ float: "right", marginRight: "20px", }}>
            <button  style={{width:54}} className="but" onClick={cb} type="primary">{language().modal_ok}</button>
          </div>
          </div>
        </div>
      </div>,
      this.node
    );
  }
}






